import React, { useState } from 'react';
import Icon from '../../../components/AppIcon';

const CorporateTaxAccountsGuide = () => {
  const [open, setOpen] = useState(false);

  return (
    <div className="rounded-xl border border-border bg-card overflow-hidden" data-testid="corporate-tax-accounts-guide">
      <button
        type="button"
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-4 py-3 text-left hover:bg-muted/30"
      >
        <span className="text-sm font-semibold text-foreground flex items-center gap-2">
          <Icon name="Building2" size={16} className="text-primary" />
          Comptes corporatifs : CDC, IMRTD et GRIP
        </span>
        <Icon name={open ? 'ChevronUp' : 'ChevronDown'} size={18} className="text-muted-foreground" />
      </button>
      {open && (
        <div className="px-4 pb-4 text-xs text-muted-foreground space-y-3 border-t border-border pt-3">
          <p>
            <strong className="text-foreground">CDC</strong> (compte de dividende en capital) : au décès d&apos;une police corporative, crédité de 100 % du capital décès (même si un prêt collatéral est en cours). Les dividendes en capital versés aux actionnaires sont non imposables.
          </p>
          <p>
            <strong className="text-foreground">IMRTD</strong> : crédit sur revenus de placement passif; remboursé en partie lors de dividendes imposables (ordinaires ou admissibles) versés.
          </p>
          <p>
            <strong className="text-foreground">GRIP</strong> : plafonne les dividendes admissibles. Saisissez un solde d&apos;ouverture ou un crédit annuel simplifié (% revenu actif).
          </p>
          <p className="text-amber-700 bg-amber-50 border border-amber-200 rounded-md p-2">
            Estimations ImmoIQ — validez avec votre fiscaliste (AAPE, conventions, retenues non modélisées en détail).
          </p>
        </div>
      )}
    </div>
  );
};

export default CorporateTaxAccountsGuide;
